import React from 'react';
import { useTranslation } from 'react-i18next';
import isNil from '../../../core/helpers/is-nil';
import { useSeriesQuery } from '../../../modules/series/queries';
import { GridContainer, GridItem } from '../../../visual-components/grid/grid';
import { Spacer } from '../../../visual-components/spacer/spacer';
import { TeaserCardLayout } from '../../../visual-components/teaser-card-layout/teaser-card-layout';
import { TeaserCard } from '../../../visual-components/teaser-card/teaser-card';
import { Divider } from '../../../visual-components/divider/divider';

export const PopularSeries: React.FC = () => {
  const { data: series } = useSeriesQuery();
  const { t } = useTranslation();

  const showPopularSeries = !isNil(series) && series.items.length > 0;

  if (!showPopularSeries) {
    return null;
  }

  return (
    <GridContainer>
      <GridItem>
        <Spacer size="10" />
        <Divider />
      </GridItem>
      <GridItem span="12">
        <TeaserCardLayout sectionTitle={t('global.popularSeries')} variant="carousel">
          {series?.items.map(({ seriesName, seriesNumber, headerImage, seriesUrl, subtitle, seriesNumberColor }) => (
            <TeaserCard
              key={`${seriesName}_${seriesNumber}`}
              detailsLink={seriesUrl}
              imgSrc={headerImage}
              series={seriesName}
              seriesDescription={subtitle}
              seriesNumber={seriesNumber}
              seriesNumberColor={seriesNumberColor ?? undefined}
            />
          ))}
        </TeaserCardLayout>
      </GridItem>
    </GridContainer>
  );
};
